<template>
    <div class="containar">
      <div class="content-title">
        <h2>シンプルコメント欄</h2>
        <p>youtubeLIVE・Twitchのコメント欄のフォントと色をカスタマイズできます</p>
      </div>
      <div class="contents-block">
      <div
        class="line__left"
        v-bind:class="fontStyle"
        v-bind:style="{ color: colors.hex }"
      >
        <div class="line__left-text">
          <div class="text">こんにちは🐟</div>
        </div>
        <div class="line__left-text">
          <div class="text">いい天気ですね</div>
        </div>
      </div>
      <div class="set">
          <h3>フォント選択</h3>
          <div class="font-dropdown-container">
            <div class="custom-font-dropdown" :class="{ open: fontDropdownOpen }">
              <div class="dropdown-selected" @click="toggleFontDropdown">
                <span :class="getCurrentFontClass()" class="selected-font-preview">{{ getCurrentFontName() }}</span>
                <span class="dropdown-arrow">▼</span>
              </div>
                          <div class="dropdown-options" v-if="fontDropdownOpen">
              <div v-for="category in fontCategories" :key="category.label" class="font-category">
                <div class="category-label">{{ category.label }}</div>
                <div v-for="font in category.fonts" :key="font.value" 
                     class="dropdown-option" :class="font.class"
                     @click="selectFont(font.value)">
                  <span class="font-preview-text">いい天気ですね</span>
                  <span class="font-name-small">{{ font.name }}</span>
                </div>
              </div>
            </div>
            </div>
          </div>
        <h3>カラー選択</h3>
        <div class="color-picker-wrapper">
          <chrome-picker :value="colors" v-model="colors"></chrome-picker>
        </div>
        <h3>コピペ用CSS</h3>
        <div class="url-description">
          <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
        </div>
        <h4>YouTubeLIVEコメント欄のカスタムCSS</h4>
        <div class="url-container">
          <textarea id="target" readonly class="url-input textarea" v-model="resultCSS" />
          <button @click="copy" class="url-copy-btn">
            <span>コピー</span>
          </button>
        </div>
        <h4>Twitchコメント欄のカスタムCSS</h4>
        <div class="url-container">
          <textarea id="target" readonly class="url-input textarea" v-model="twresultCSS" />
          <button @click="copy2" class="url-copy-btn">
            <span>コピー</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Chrome } from "vue-color";
export default {
  name: "app",
  components: {
    "chrome-picker": Chrome,
  },
  data() {
    return {
      fontstyle: "font1",
      colors: {
        hex: "#000000",
        hsl: { h: 150, s: 0, l: 0, a: 1 },
        rgba: { r: 0, g: 0, b: 0, a: 1 },
        a: 1,
      },
      data1: "aa",
      importcss:
        '@import url("https://ruri.info/tool/css/simpleComment.css");\nyt-live-chat-text-message-renderer #message,\nyt-live-chat-text-message-renderer #message * {\ncolor:',
      fontcss: '!important;\nfont-family: "M PLUS 1p", sans-serif;}',
      twimportcss:'@import url("https://ruri.info/tool/css/tw-simpleComment.css");\n.chat-line__no-background{\ncolor:',
      fontDropdownOpen: false,
              fontCategories: [
          {
            label: 'ゴシック',
            fonts: [
              { value: 'font1', name: 'Zen角ゴシックAntique', class: 'font1' },
              { value: 'font4', name: 'DotGothic16', class: 'font4' },
              { value: 'font7', name: 'M PLUS Rounded 1c', class: 'font7' },
              { value: 'font6', name: 'キウイ丸', class: 'font6' }
            ]
          },
          {
            label: 'ポップ',
            fonts: [
              { value: 'font2', name: 'はちまるポップ', class: 'font2' },
              { value: 'font8', name: 'ロックンロールOne', class: 'font8' }
            ]
          },
          {
            label: '明朝',
            fonts: [
              { value: 'font12', name: 'さわらび明朝', class: 'font12' },
              { value: 'font13', name: 'しっぽり明朝', class: 'font13' }
            ]
          },
          {
            label: 'デザイン',
            fonts: [
              { value: 'font3', name: 'Stick', class: 'font3' },
              { value: 'font5', name: '解星デコール', class: 'font5' },
              { value: 'font9', name: '佑字【舞】', class: 'font9' },
              { value: 'font10', name: '油性マジック', class: 'font10' }
            ]
          }
        ]
    };
  },
  methods: {
    copy() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.importcss + this.colors.hex + this.fontcss);
        console.log("コピー完了");
        return true;
      } else {
        return false;
      }
    },
    copy2 () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.twimportcss + this.colors.hex + this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    setFontCss: function () {
      switch(this.fontstyle){
            case 'font1':
                this.fontcss = '!important;\nfont-family: "Zen Kaku Gothic Antique", sans-serif;}'
                break;
            case 'font2':
                this.fontcss = '!important;\nfont-family: "Hachi Maru Pop", cursive;}'
                break;
            case 'font3':
                this.fontcss = '!important;\nfont-family: "Stick", sans-serif;}'
                break;
            case 'font4':
                this.fontcss = '!important;\nfont-family: "DotGothic16", sans-serif;}'
                break;
            case 'font5':
                this.fontcss = '!important;\nfont-family: "Kaisei Decol", serif;}'
                break;
            case 'font6':
                this.fontcss = '!important;\nfont-family: "Kiwi Maru", serif;}'
                break;
            case 'font7':
                this.fontcss = '!important;\nfont-family: "M PLUS Rounded 1c", sans-serif;}'
                break;
            case 'font8':
                this.fontcss = '!important;\nfont-family: "RocknRoll One", sans-serif;}'
                break;
            case 'font9':
                this.fontcss = '!important;\nfont-family: "Yuji Mai", serif;}'
                break;
            case 'font10':
                this.fontcss = '!important;\nfont-family: "Yusei Magic", sans-serif;}'
                break;
            case 'font12':
                this.fontcss = '!important;\nfont-family: "Sawarabi Mincho", serif;";}'
                break;
            case 'font13':
                this.fontcss = '!important;\nfont-family: "Shippori Mincho", serif;}'
                break;
        }
    },
    toggleFontDropdown() {
      this.fontDropdownOpen = !this.fontDropdownOpen;
    },
    selectFont(fontValue) {
      this.fontstyle = fontValue;
      this.fontDropdownOpen = false;
    },
    getCurrentFontName() {
      for (const category of this.fontCategories) {
        const font = category.fonts.find(f => f.value === this.fontstyle);
        if (font) return font.name;
      }
      return 'Zen角ゴシックAntique';
    },
    getCurrentFontClass() {
      for (const category of this.fontCategories) {
        const font = category.fonts.find(f => f.value === this.fontstyle);
        if (font) return font.class;
      }
      return 'font1';
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.custom-font-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.fontDropdownOpen = false;
      }
    }
  },
  mounted: function () {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    fontstyle: function () {
      this.setFontCss();
    },
  },
  computed: {
    resultCSS() {
      return this.importcss + this.colors.hex + this.fontcss;
    },
    twresultCSS(){
        return this.twimportcss + this.colors.hex + this.fontcss;
    },
    fontStyle: function() {
      if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5';
      }
      else if (this.fontstyle === 'font6') {
        return 'font6';
      }
      else if (this.fontstyle === 'font7') {
        return 'font7';
      }
      else if (this.fontstyle === 'font8') {
        return 'font8';
      }
      else if (this.fontstyle === 'font9') {
        return 'font9';
      }
      else if (this.fontstyle === 'font10') {
        return 'font10';
      }
      else if (this.fontstyle === 'font12') {
        return 'font12';
      }
      else if (this.fontstyle === 'font13') {
        return 'font13';
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Stick&display=swap");
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Kaisei+Decol:wght@500&family=Kiwi+Maru:wght@500&family=M+PLUS+Rounded+1c:wght@500&family=RocknRoll+One&family=Sawarabi+Mincho&family=Shippori+Mincho:wght@500&family=Yuji+Mai&family=Yusei+Magic&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.containar{
  margin: 0 auto;
  max-width: 767px;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3 {
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}

.main {
  max-width: 767px;
  margin: 0 auto;
  background-color: #F2F0E9;
}


.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  min-width: 0;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
  }
}
.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  margin-left:12px;
}

/* コメントエリア */
.preview {
  padding: 2px 12px;
}

.text {
  margin: 6px 20px;
  padding: 10px 15px;
  position: relative;
  border-radius: 20px;
}

.select-gradation {
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font {
  font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off {
  display: none;
}

.font1 {
  font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.font2 {
  font-family: "Hachi Maru Pop", cursive;
}
.font3 {
  font-family: "Stick", sans-serif;
}
.font4{
    font-family: "DotGothic16", sans-serif;
}
.font5{
    font-family: "Kaisei Decol", serif;
}
.font6{
    font-family: "Kiwi Maru", serif;
}
.font7{
    font-family: "M PLUS Rounded 1c", sans-serif;
}
.font8{
    font-family: "RocknRoll One", sans-serif;
}
.font9{
    font-family: "Yuji Mai", serif;
}
.font10{
    font-family: "Yusei Magic", sans-serif;
}
.font12{
    font-family: 'Sawarabi Mincho', serif;
}
.font13{
    font-family: 'Shippori Mincho', serif;
}
/* Custom Font Dropdown */
.font-dropdown-container {
  margin-top: 12px;
  position: relative;
}

.custom-font-dropdown {
  position: relative;
  width: 100%;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-selected:hover {
  box-shadow: 0 0 0 1px #999 inset;
}

.custom-font-dropdown.open .dropdown-selected {
  box-shadow: 0 0 0 2px #0f172a;
}

.selected-font-preview {
  flex: 1;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}

.custom-font-dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #ccc;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 2px;
}

.font-category {
  border-bottom: 1px solid #f0f0f0;
}

.font-category:last-child {
  border-bottom: none;
}

.category-label {
  padding: 8px 16px 4px 16px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #f9fafb;
  border-bottom: 1px solid #f0f0f0;
}

.dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  background-color: #f8f8f8;
}

.font-preview-text {
  font-size: 14px;
  margin-bottom: 6px;
  letter-spacing: 0.05em;
}

.font-name-small {
  font-size: 11px;
  color: #666;
  font-family: system-ui, -apple-system, sans-serif;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 12px;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

.color-picker-wrapper .vc-hue-pointer,
.color-picker-wrapper .vc-alpha-pointer {
  width: 16px;
  height: 16px;
}

.color-picker-wrapper .vc-hue-picker,
.color-picker-wrapper .vc-alpha-picker {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-wrapper .vc-saturation-pointer {
  width: 14px;
  height: 14px;
}

.color-picker-wrapper .vc-saturation-circle {
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 76px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}

.line__left{
  display: block;
  white-space: nowrap;
}
</style>